import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { ToggleConditionsGlobalContext } from '@Pages/Results/ToggleConditionsGlobalContext';

function ToggleConditionsGlobalProvider({ children }) {
  const [showConditions, setShowConditions] = useState(true);
  const contextValue = useMemo(() => [showConditions, setShowConditions], [showConditions]);
  return <ToggleConditionsGlobalContext.Provider value={contextValue}>{children}</ToggleConditionsGlobalContext.Provider>;
}

ToggleConditionsGlobalProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ToggleConditionsGlobalProvider;
